import React from 'react';
import { Helmet } from 'react-helmet';
import axiosInstance from '../../config/axios';

// متغيرات عامة لتتبع حالة الطلب والبيانات
let globalSeoData = {
  siteTitle: 'دوز التعليمية',
  homePageTitle: 'منصة دوز التعليمية',
  siteDescription: 'وجهتك الأولى في تطوير مستواك'
};

// دالة لجلب بيانات SEO وتحديث localStorage
export const fetchSeoData = async () => {
  // نتحقق إذا كنا قد قمنا بجلب البيانات بالفعل في هذه الجلسة
  const isFetchedThisSession = sessionStorage.getItem('seoDataFetched');
  
  if (isFetchedThisSession === 'true') {
    // تم جلب البيانات بالفعل في هذه الجلسة، استخدام بيانات localStorage
    return globalSeoData;
  }

  // نحاول استرجاع البيانات من localStorage أولاً
  try {
    const storedData = localStorage.getItem('seoData');
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      globalSeoData = parsedData;
      // استخدام البيانات من localStorage
    }
  } catch (error) {
    // خطأ في قراءة البيانات من localStorage
  }

  // نجلب البيانات الجديدة من السيرفر
  try {
    const response = await axiosInstance.get('/api/settings/seo');
    if (response.data) {
      // استجابة الخادم
      // نحدث البيانات العامة
      if (response.data.siteTitle) globalSeoData.siteTitle = response.data.siteTitle;
      if (response.data.homePageTitle) globalSeoData.homePageTitle = response.data.homePageTitle;
      if (response.data.siteDescription) globalSeoData.siteDescription = response.data.siteDescription;
      
      // نحفظ في localStorage
      localStorage.setItem('seoData', JSON.stringify(globalSeoData));
      
      // نضبط متغير الجلسة ليشير إلى أننا قمنا بجلب البيانات بالفعل
      sessionStorage.setItem('seoDataFetched', 'true');
    }
  } catch (error) {
    // خطأ في جلب بيانات SEO
  }
  
  return globalSeoData;
};

const PageTitle = ({ title }) => {
  const [siteTitle, setSiteTitle] = React.useState(globalSeoData.siteTitle);

  React.useEffect(() => {
    const loadSeoData = async () => {
      const data = await fetchSeoData();
      setSiteTitle(data.siteTitle);
    };

    loadSeoData();
  }, []);

  return (
    <Helmet>
      <title>{title} | {siteTitle}</title>
    </Helmet>
  );
};

export default PageTitle;
